import React from "react";
import { Field, reduxForm } from "redux-form";
import LoginRegister from "../../consts/LoginRegister";
import { compose } from "redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchForgetPassword } from "../../actions/user_actions";

import "./style.css";
import Logo from "../../img/iconsGradient.png";

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = "Obligatorio";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values && values.email)
  ) {
    errors.email = "Dirección de correo electrónico no válida";
  }

  return errors;
};

const renderField = ({
  input,
  name,
  className,
  type,
  placeholder,
  meta: { touched, error }
}) => {
  return (
    <div>
      <div>
        <input
          className={className}
          {...input}
          type={type}
          placeholder={placeholder}
        />
        {touched && (error && <span>{error}</span>)}
      </div>
    </div>
  );
};

class LostPassword extends React.Component {
  render() {
    const { handleSubmit } = this.props;

    const onFormSubmit = data => {
      let values = {
        ForgetPassword: {
          email: data.email
        }
      };
      this.props.dispatch(fetchForgetPassword(values));
    };

    return (
      <LoginRegister>
        <div className="login-aside w-50 d-flex align-items-center justify-content-center bg-white">
          <div className="container container-login container-transparent animated fadeIn">
            <div className="login-form">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                  marginTop: -50
                }}
              >
                <img width="200" height="200" src={Logo} alt="logo" />
              </div>

              <h1 className="text-center">Novem</h1>
              <div className="form-group">
                <label className="placeholder">
                  <b>Email</b>
                </label>
                <Field
                  className="form-control"
                  name="email"
                  component={renderField}
                  type="email"
                  placeholder="Email"
                />
              </div>
              <div>
                <button
                  onClick={handleSubmit(onFormSubmit)}
                  className="btn btn-primary col-md-5 float-right mt-3 mt-sm-0 fw-bold"
                >
                  Enviar Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </LoginRegister>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchForgetPassword }, dispatch);

export default compose(
  reduxForm({
    form: "LostPassword",
    validate
  }),
  connect(
    null,
    mapDispatchToProps
  )
)(LostPassword);
